import { Component, OnInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { BnNgIdleService } from 'bn-ng-idle';
import { AppTokenHandler } from './common/app-token-handler';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    constructor(
        private router: Router, 
        private _elementRef: ElementRef,
        private bnIdle: BnNgIdleService,
        private appToken: AppTokenHandler) {
    }
    ngOnInit() {
        this._elementRef.nativeElement.removeAttribute("ng-version");

        this.bnIdle.startWatching(60 * 60).subscribe((isTimedOut: boolean) => {
            if (isTimedOut && this.appToken.getLoginUserInfo()) {
                alert('Session Timeout occurs');
                this.router.navigate(['logout']);
            }
          });
    }
}
